import { FaqComponent } from '../../../Common/FAQS';
import { QuickSummarySection } from '../components/QuickSummarySection';
import { DETAILED_STEP_FAQs } from './detailed-step-faq.data';
import { QUICK_SUMMARY_DATA } from './quick-summary.data';

export const DETAILED_STEP_DATA = (activeTab: string) => [
  {
    id: 'quickSummary',
    title: 'Quick Summary',
    content: (
      <QuickSummarySection
        title={QUICK_SUMMARY_DATA[activeTab]?.title}
        content={QUICK_SUMMARY_DATA[activeTab]?.content}
      />
    ),
  },
  {
    id: 'faqs',
    title: 'FAQ’s',
    content: (
      <div className="m-10 sm:m-6">
        <FaqComponent
          FAQS={DETAILED_STEP_FAQs[activeTab] || []}
          heading=""
          variant="itrGuide"
          expanded="false"
          parentClass="border border-[#E0EDFE] rounded-2xl"
        />
      </div>
    ),
  },
];
